import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api';
import Nav from '../components/Nav';
import Chat from '../components/Chat';

function Thoughts() {
  const [topics, setTopics] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    api.get('/public/topics')
      .then(({ data }) => setTopics(data.topics))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <div>
      <Nav active="thoughts" />
      <div className="page">
        <div className="section-header">
          <h1 className="section-title">Thoughts</h1>
          <span className="section-subtitle">unfiltered</span>
        </div>

        {loading ? (
          <div className="loading">loading...</div>
        ) : topics.length === 0 ? (
          <div className="empty">
            <h2>Mind is quiet</h2>
            <p>No random thoughts yet. They'll come when they come.</p>
          </div>
        ) : (
          <div className="topics-grid">
            {topics.map((topic) => (
              <div
                key={topic.id}
                className="topic-card"
                onClick={() => navigate(`/thoughts/${topic.id}`)}
              >
                {topic.category && <div className="topic-category">{topic.category}</div>}
                <div className="topic-title">{topic.title}</div>
                <p className="topic-preview">{topic.content}</p>
                <div className="day-meta" style={{ marginTop: '12px' }}>
                  {topic.mood && <span className="badge badge-mood">{topic.mood}</span>}
                  {topic.tags && topic.tags.map(t => (
                    <span key={t} className="badge badge-tag">#{t}</span>
                  ))}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
      <Chat />
    </div>
  );
}

export default Thoughts;
